import { PieChart } from "devextreme-react";
import { Series } from "devextreme-react/pie-chart";
import { useCallback } from "react";
import { getBasicLegend } from "./utils/getBasicLegend.ts";
import { getBasicSerieLabel } from "./utils/getBasicSerieLabel.ts";
import { ChartCore } from "./ChartCore.tsx";
import type { ChartProps } from "./ChartProps.ts";
import formatArgumentLabel from "./utils/argumentFormat.ts";

export default function Pie(props: ChartProps) {
  const updateRef = useCallback(
    (ref: PieChart) => {
      props.exportFunc(ref?.instance.exportTo.bind(ref.instance));
    },
    [props]
  );
  const renderSeries = () => {
    return props.args.map((arg) => {
      return (
        <Series
          key={arg.meta.name}
          argumentField={arg.meta.name}
          valueField={props.values[0]?.config.guid}
          name={props.values[0]?.config.guid}
          label={getBasicSerieLabel(props.values[0]?.config.guid, props.settings, props.data)}
        />
      );
    });
  };

  return (
    <ChartCore {...props}>
      <PieChart
        ref={updateRef}
        dataSource={props.dataSource}
        legend={{
          ...getBasicLegend(props.settings),
          customizeText: ({ pointName }: { pointName?: string }) =>
            formatArgumentLabel(props.args, pointName, props.data),
        }}
      >
        {renderSeries()}
      </PieChart>
    </ChartCore>
  );
}
